import { useState } from 'react';
import { useLocalStorage, STORAGE_KEYS } from '../../../services/storage';
import useTablaPrefs from '../../../components/tabla/useTablaPrefs';

/**
 * Favoritos del menú lateral (ids de item, en el orden que elige el usuario) y
 * arrastre para reordenarlos. Se guardan por usuario en la BD (como las columnas de las
 * tablas); la versión antigua de este navegador se usa una vez si la BD aún no tiene nada.
 */
const useFavoritosSidebar = () => {
  const { prefs, actualizar } = useTablaPrefs('sidebar');
  const [antiguos] = useLocalStorage(STORAGE_KEYS.SIDEBAR_FAVORITOS, []);
  const guardados = prefs.favorites ?? antiguos;
  const setGuardados = (lista) => actualizar({ favorites: lista });
  const favoritos = Array.isArray(guardados) ? guardados : [];
  const [origen, setOrigen] = useState(null);
  const [destino, setDestino] = useState(null);

  const alternar = (id) =>
    setGuardados(favoritos.includes(id) ? favoritos.filter((f) => f !== id) : [...favoritos, id]);

  const mover = (de, a) => {
    if (de === a || !favoritos.includes(de)) return;
    const sin = favoritos.filter((f) => f !== de);
    const i = sin.indexOf(a);
    sin.splice(i < 0 ? sin.length : i, 0, de);
    setGuardados(sin);
  };

  const arrastreDe = (id) => ({
    arrastrando: origen === id,
    encima: destino === id && origen !== id,
    onDragStart: (e) => {
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text/plain', String(id));
      setOrigen(id);
    },
    onDragOver: (e) => {
      if (origen === null) return;
      e.preventDefault();
      setDestino(id);
    },
    onDragLeave: () => setDestino((d) => (d === id ? null : d)),
    onDrop: (e) => {
      e.preventDefault();
      if (origen !== null) mover(origen, id);
      setOrigen(null);
      setDestino(null);
    },
    onDragEnd: () => {
      setOrigen(null);
      setDestino(null);
    },
  });

  return { favoritos, alternar, arrastreDe };
};

export default useFavoritosSidebar;
